module.exports = __webpack_public_path__ + "static/media/lucidagrande.cab01315.ttf";